import moment from 'moment';

type DateType = { raw: Date; string: string };

export const formatDateFromApi = (
  date: string | undefined | null,
): DateType | null => {
  if (date) {
    const objectDate = new Date(date);
    return { raw: objectDate, string: objectDate.toLocaleDateString() };
  }
  return null;
};

type ReturnType = DateType | Array<unknown> | { [key: string]: unknown } | null;

export const getFormatedDates = (param: unknown): ReturnType => {
  if (param == null) {
    // eslint-disable-next-line no-console
    console.warn('Given date to format is null or undefined');
    return null;
  }
  if (typeof param === 'string') {
    return formatDateFromApi(param);
  }
  if (Array.isArray(param)) {
    return param.map((date: unknown) => getFormatedDates(date));
  }
  if (typeof param === 'object' && param !== null) {
    // '&& param !== null' is useless because of first condition
    // but TS cannot handle it
    return Object.keys(param).reduce(
      (acc: { [key: string]: unknown }, curr: string) => {
        acc[curr] = '/!\\ FIXME /!\\';
        // acc[curr] = getFormatedDates(param[curr]);

        /**
         * FIXME: fix typing issue and use this file instead of .js
         */

        return acc;
      },
      {},
    );
  }
  // eslint-disable-next-line no-console
  console.warn('Given param', param, 'cannot be reduced to a date type');
  return null;
};

export const EventStatus = {
  INCOMING: 'incoming',
  RUNNING: 'running',
  ENDED: 'ended',
};

/**
 * Return status by given dates
 **/
export function getPublicationStatusFromDate(
  startDate: string | null | undefined,
  endDate: string | null | undefined,
) {
  const now = moment();
  const start = moment(startDate);
  const end = moment(endDate);
  if (now < start) {
    return EventStatus.INCOMING;
  }

  if ((start < now && now < end) || (start < now && !end.isValid())) {
    return EventStatus.RUNNING;
  }
  // Event is over
  return EventStatus.ENDED;
}
